import {ApiError} from './apiError';

export class PermissionDeniedError extends ApiError {
  constructor(message?: string) {
    super(message || '403 Permission denied');
  }
}
